import React from "react";
import { useNavigate } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import TabCardGrid2 from "./cards/TabCardGrid2";
import { useState, useEffect } from 'react';
import Light from "./headers/light";
import LightAdmin from "./headers/lightAdmin";
import { useTranslation } from 'react-i18next';
import Footerr from "./footers/Footer";
import OurPicks from "./sections/OurPicks";
import WhySection from "./sections/WhySection";
import ForceOfNatureSection from "./ForceOfNatureSection";
import image from "../images/image prdts.jpg"
import AgencyIntroBanner from "components/sections/AgencyIntroBanner";

export default () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [role, setRole] = useState('');
    const [productCosmetiquesAlimentaires, setProductCosmetiquesAlimentaires] = useState([]);
    const [textiles, setTextiles] = useState([]);
    const [parfums, setParfums] = useState([]);
    const [produitsNaturels, setProduitsNaturels] = useState([]);
    const [accessoiresTelephone, setAccessoiresTelephone] = useState([]);
    const { i18n } = useTranslation();
  useEffect(() => {
      const userRole = localStorage.getItem('role');
          setRole(userRole); // Set the role state based on what’s stored
    }, []);

useEffect(() => {
  fetch(`  https://plateformewmg.cloud/api/cosmetiques-complements?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setProductCosmetiquesAlimentaires(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching :", error));
}, [i18n.language]);
useEffect(() => {
  fetch(`  https://plateformewmg.cloud/api/textile?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setTextiles(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching :", error));
}, [i18n.language]);
useEffect(() => {
  fetch(`  https://plateformewmg.cloud/api/parfums?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setParfums(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching :", error));
}, [i18n.language]);
useEffect(() => {
  fetch(`  https://plateformewmg.cloud/api/produits-naturels?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setProduitsNaturels(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching :", error));
}, [i18n.language]);
useEffect(() => {
  fetch(`  https://plateformewmg.cloud/api/accessoires-telephone?lang=${i18n.language}`)
    .then((response) => response.json())
    .then((data) => setAccessoiresTelephone(Array.isArray(data) ? data : []))
    .catch((error) => console.error("Error fetching :", error));
}, [i18n.language]);
  return (
    <AnimationRevealPage>
{role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}
      <Hero
        primaryButtonStyles="bg-red-500 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg"
      />
      <br/>

      <OurPicks />
           <TabCardGrid2
  heading={t('Nos_produits_cosmetiques_et_complementaires')}
  products={productCosmetiquesAlimentaires}
  viewMoreHref="/cosmetiques-complements"
/>
 <TabCardGrid2
  heading={t('Nos_produits_textiles_et_habillement')}
  products={textiles}
  viewMoreHref="/textile-habillement"
 />
            <WhySection />

<TabCardGrid2
  heading={t('Nos_parfums')}
  products={parfums}
  viewMoreHref="/parfums"
/>
<TabCardGrid2
  heading={t('Nos_produits_naturels')}
  products={produitsNaturels}
  viewMoreHref="/produits-naturels"
/>
 <AgencyIntroBanner
  heading={t('agencyIntro.heading')}
  content={t('agencyIntro.content')}
  ctaText={t('agencyIntro.cta')}
  onCtaClick={() => navigate('/contact')}
 />
<TabCardGrid2
  heading={t('Nos_accessoires_telephone')}
  products={accessoiresTelephone}
  viewMoreHref="/accessoires-telephone"
/>
      <wbr />
      <wbr />
<ForceOfNatureSection
  imageSrc={image}
  onButtonClick={() => navigate("/Boutique")}
/>
      <Footerr />
    </AnimationRevealPage>
  );
}
